export enum languages {
  EN = "en",
  AR = "ar",
}
